/**
 * Prepares CMS HTML for dangerouslySetInnerHTML.
 * Unescapes HTML entities and converts Markdown-style links to <a> tags.
 */
export function formatCmsHtml(content) {
  if (!content || typeof content !== "string") return "";

  let html = content;

  // Unescape common HTML entities (including double-escaped content)
  const unescapeOnce = (str) =>
    str
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&");

  // Run twice to handle double-escaped strings like &amp;lt;
  html = unescapeOnce(unescapeOnce(html));

  // Convert Markdown-style links [text](url) to anchor tags
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  return html;
}
